import React from "react";

// const points = ["Point 1", "Point 2", "Point 3"];

const ScrollingText = () => {
  return (
    <div
      className="text-scrolling mb-4  ml-0 mr-0  rowb row-1"
      style={{
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        color: "#f58b29",
        backgroundColor: "#ffedde",
        boxShadow: "6px 6px 6px #f0f0f0",
        //   borderRadius: 6,
        textAlign: "center",
        // height: 40,
        borderRadius: 10,
        border: "1px solid #f58b29 ",
      }}
    >
      <p>
        <span className="bold">•</span>

        <span>Start redeeming today and enjoy your rewards! </span>

        <span className="bold">•</span>

        <span>
          Redeem your points in denominations of{" "}
          <span className="bold ml-1"> {`  ₹100 or more!`}</span>
        </span>

        <span className="bold mr-16">•</span>

        <span>
          <span className="bold mr-1"> 100 </span>
          reward points = <span className="bold">₹1</span>
        </span>

        <span className="bold">•</span>

        <span>Start redeeming today and enjoy your rewards! </span>

        <span className="bold">•</span>

        <span>
          Redeem your points in denominations of{" "}
          <span className="bold ml-1"> {`  ₹100 or more!`}</span>
        </span>

        <span className="bold mr-16">•</span>

        <span>
          <span className="bold mr-1"> 100 </span>
          reward points = <span className="bold">₹1</span>
        </span>

        <span className="bold">•</span>
      </p>
    </div>
  );
};

export default ScrollingText;
